import React from 'react';
import { motion } from 'framer-motion';

const connectors = [
  { name: 'Salesforce', color: '#00A1E0' },
  { name: 'HubSpot', color: '#FF7A59' },
  { name: 'Google Analytics', color: '#F9AB00' },
  { name: 'Stripe', color: '#635BFF' },
  { name: 'Shopify', color: '#96BF48' },
  { name: 'PostgreSQL', color: '#336791' },
  { name: 'MySQL', color: '#4479A1' },
  { name: 'MongoDB', color: '#47A248' },
  { name: 'Snowflake', color: '#29B5E8' },
  { name: 'BigQuery', color: '#4285F4' },
  { name: 'AWS S3', color: '#FF9900' },
  { name: 'Zendesk', color: '#03363D' },
  { name: 'Intercom', color: '#1F8DED' },
  { name: 'Slack', color: '#4A154B' },
  { name: 'Jira', color: '#0052CC' },
  { name: 'Asana', color: '#F06A6A' },
  { name: 'Notion', color: '#000000' },
  { name: 'Airtable', color: '#18BFFF' },
  { name: 'Mixpanel', color: '#7856FF' },
  { name: 'Amplitude', color: '#1E61F0' },
  { name: 'Segment', color: '#52BD94' },
  { name: 'Twilio', color: '#F22F46' },
  { name: 'Mailchimp', color: '#FFE01B' },
  { name: 'SendGrid', color: '#1A82E2' },
  { name: 'QuickBooks', color: '#2CA01C' },
  { name: 'Xero', color: '#13B5EA' },
  { name: 'NetSuite', color: '#125580' },
  { name: 'SAP', color: '#0FAAFF' },
  { name: 'Oracle', color: '#F80000' },
  { name: 'Marketo', color: '#5C4C9F' },
];

const ConnectorBadge = ({ name, color }) => (
  <div
    className="flex-shrink-0 bg-white border-4 border-black px-6 py-3 shadow-[4px_4px_0_0_#1a1a1a] hover:shadow-[6px_6px_0_0_#1a1a1a] hover:translate-x-[-2px] hover:translate-y-[-2px] transition-all cursor-default"
  >
    <div className="flex items-center gap-3">
      <div
        className="w-3 h-3 rounded-full border-2 border-black"
        style={{ backgroundColor: color }}
      />
      <span className="font-bold text-black whitespace-nowrap">{name}</span>
    </div>
  </div>
);

export default function ConnectorsCarousel() {
  const row1 = connectors.slice(0, 15);
  const row2 = connectors.slice(15, 30);

  return (
    <section className="bg-[#f5f5f0] py-20 overflow-hidden relative">
      {/* Grid background */}
      <div className="absolute inset-0 opacity-20">
        <div className="w-full h-full" style={{
          backgroundImage: `
            linear-gradient(to right, #1a1a1a 1px, transparent 1px),
            linear-gradient(to bottom, #1a1a1a 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 mb-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <div className="inline-block bg-[#4361ee] text-white px-4 py-2 font-bold text-sm uppercase tracking-wider border-4 border-black mb-6">
            600+ коннекторов
          </div>
          <h2 className="text-[clamp(1.5rem,8.6vw,2.25rem)] md:text-5xl font-black text-black mb-4">
            Подключайте всё
          </h2>
          <p className="text-xl text-black/60 font-medium max-w-2xl mx-auto">
            CRM, базы данных, SaaS-сервисы, рекламные кабинеты — если там есть данные, мы их заберём.
          </p>
        </motion.div>
      </div>

      {/* Scrolling rows */}
      <div className="space-y-6">
        {/* Row 1 — scrolls left */}
        <div className="relative">
          <motion.div
            className="flex gap-4"
            animate={{ x: ['0%', '-50%'] }}
            transition={{
              duration: 30,
              repeat: Infinity,
              ease: 'linear'
            }}
          >
            {[...row1, ...row1].map((connector, i) => (
              <ConnectorBadge key={i} {...connector} />
            ))}
          </motion.div>
        </div>

        {/* Row 2 — scrolls right */}
        <div className="relative">
          <motion.div
            className="flex gap-4"
            animate={{ x: ['-50%', '0%'] }}
            transition={{
              duration: 35,
              repeat: Infinity,
              ease: 'linear'
            }}
          >
            {[...row2, ...row2].map((connector, i) => (
              <ConnectorBadge key={i} {...connector} />
            ))}
          </motion.div>
        </div>
      </div>

      {/* Edge fades */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#f5f5f0] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#f5f5f0] to-transparent z-10 pointer-events-none" />
    </section>
  );
}
